// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"b07c5f7a","373":"9e9d6b8d","484":"ca47c2d3","550":"5ce9971d","684":"1256dfbe","777":"9567a285","840":"ce1955bc","953":"2ce01707"}[chunkId] + ".chunk.css";
};